import Navbar from './components/Navbar';
import MainContainer from './components/MainContainer';

function App() {
	return (
		<div className='App'>
			<Navbar />
			<MainContainer />
		</div>
	);
}

export default App;
